import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {

  return (
    <section className="hero">
      <h1>MIDEN HUB</h1>
      <p>A community-friendly platform to explore and learn Miden.</p>
      <div className="cta-buttons">
        <Link to="/playground" className="btn btn-primary">Playground</Link>
        <Link to="/explore" className="btn btn-secondary">Explore</Link>
      </div>
    </section>
  );
};

export default Hero;